module.exports = __webpack_public_path__ + "static/media/bell_beaker_eba_england_text_02.ce44cd90.jpg";